import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";

import firebase from "firebase/compat/app";

const Chapter6_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was wird als eine der Haupttechnologien in der Zukunft der Cloud betrachtet, um die Datenverarbeitung noch schneller und effizienter zu gestalten?",
      options: [
        {
          value: "A",
          label: "Quantencomputing",
        },
        {
          value: "B",
          label: "Bluetooth 5.0",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welches Ziel verfolgen Cloud-Anbieter mit der „Green Cloud“?",
      options: [
        {
          value: "A",
          label:
            "Den Energieverbrauch und CO₂-Ausstoß von Rechenzentren zu senken.",
        },
        {
          value: "B",
          label: "Die Bandbreite in 5G-Netzen zu erhöhen.",
        },
      ],
      correct: "A",
    },
  ];

 
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 6_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "6_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("6_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 6_5.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "6_5",
              completedChapters: ["6_5"],
            });
          console.log("Dokument erstellt mit Kapitel 6_5");
        }

        navigate("/7_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  6. Sicheres Cloud Computing
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Zukunft des Cloud-Computing
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 6: Sicheres Cloud Computing
          </h3>
          <h2 className="text-center p-3">Zukunft des Cloud-Computing</h2>
          <img
            src="/images/cloud-ai.webp"
            alt="Cloud KI"
            style={{ position: "relative", maxWidth: "15%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h3 className="p-5">Künstlicher Intelligenz verändert die Cloud</h3>
          <p className="col-lg-11 mx-auto">
            Künstliche Intelligenz (KI) und die Cloud wachsen immer enger
            zusammen und schaffen gemeinsam eine dynamische, skalierbare
            Infrastruktur, die es Unternehmen ermöglicht, schneller und effizienter
            auf Daten zuzugreifen und diese zu verarbeiten. Die Kombination aus
            KI und Cloud verändert die Art und Weise, wie Daten gespeichert,
            analysiert und genutzt werden: Sie ermöglicht innovative Anwendungen
            in nahezu jeder Branche.
            <br />
            <br />
            <strong>Automatisierung und Skalierbarkeit: </strong> KI optimiert
            die Nutzung der Cloud, indem sie Prozesse automatisiert, Datenströme
            effizient verwaltet und den Ressourcenverbrauch dynamisch anpasst.
            KI-gesteuerte Algorithmen ermöglichen es Cloud-Plattformen,
            Ressourcen in Echtzeit anzupassen, was die Effizienz und
            Flexibilität erheblich steigert. Unternehmen profitieren dadurch von
            einem skalierbaren System, das sich automatisch an die aktuellen
            Anforderungen anpasst, ohne dass menschliches Eingreifen
            erforderlich ist.
            <br />
            <br />
            <strong> Fortschrittliche Datenanalyse: </strong> Cloud-Dienste mit
            integrierten KI-Funktionen bieten Unternehmen Zugang zu
            ausgeklügelten Analysewerkzeugen, die große Datenmengen verarbeiten
            und Muster erkennen können. Diese „Smart Analytics“ helfen dabei,
            fundierte Entscheidungen auf der Grundlage riesiger Datenmengen zu
            treffen, z. B. in der Gesundheitsforschung, im Finanzwesen oder in
            der Logistik. Anbieter wie Google Cloud und Microsoft Azure bieten
            spezifische KI-Dienste an, die auf maschinellem Lernen basieren und
            sich leicht in bestehende Cloud-Umgebungen integrieren lassen.
            <br />
            <br />
            <strong>Verbesserte Kundenerlebnisse: </strong>
            KI-gestützte Cloud-Dienste wie Chatbots und
            Spracherkennungsprogramme helfen Unternehmen, personalisierte
            Kundenerlebnisse zu schaffen. Diese Dienste analysieren
            Kundeninteraktionen und ermöglichen es Unternehmen, auf
            Kundenanfragen schneller und zielgerichteter zu reagieren. Zum
            Beispiel bietet Amazon Web Services (AWS) mit „Lex“ eine
            Cloud-basierte Plattform für die Entwicklung von Chatbots, die
            KI-Technologien nutzt, um Konversationen natürlicher und intuitiver
            zu gestalten.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Mit der Einführung von 5G-Übertragungsstandards können KI und Cloud-Anwendungen auf einem
            neuen Niveau agieren. 5G bietet hohe Bandbreiten und extrem niedrige
            Latenzzeiten, was für Echtzeitanwendungen entscheidend ist. Die
            Download-Geschwindigkeit ist etwa 100-mal schneller als 4G. Diese
            Vorteile ermöglichen es KI-gesteuerten Cloud-Anwendungen, nahezu in
            Echtzeit auf Daten zuzugreifen und sofortige Analysen durchzuführen.
            Insbesondere in Bereichen wie Augmented Reality (AR), autonomem
            Fahren und vernetzten Geräten (IoT) sind diese Fähigkeiten von
            großem Wert. Beispielsweise können autonome Fahrzeuge in Echtzeit
            Daten von der Cloud empfangen und verarbeiten, was dank 5G zu einer
            reibungslosen Kommunikation und schnellen Entscheidungsfindung
            führt.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Green Cloud</h3>
            <p className="col-lg-11 mx-auto">
              Mit der wachsenden Verbreitung von Cloud-Computing steigt auch die
              Notwendigkeit, dessen{" "}
              <strong> Umweltbelastungen zu minimieren. </strong> Die riesigen
              Rechenzentren der Cloud verbrauchen immense Mengen an Energie und
              Wasser, insbesondere für Kühlprozesse. Initiativen wie die
              „Green Cloud“ zielen darauf ab, Cloud-Technologien nachhaltiger zu
              gestalten, indem sowohl Cloud-Anbieter als auch Unternehmen
              Maßnahmen ergreifen, um
              <strong> Energieverbrauch und Ressourcenverschwendung </strong> zu
              reduzieren.
              <br />
              <br />
              Google Cloud war 2017 der erste Anbieter, der seinen gesamten
              Energiebedarf durch <strong> erneuerbare Energien </strong>{" "}
              deckte. Amazon Web Serve (AWS) plant, bis 2025 vollständig
              CO₂-neutral zu werden, während Microsoft Azure sich verpflichtet
              hat, bis 2030 nicht nur CO₂-neutral, sondern CO₂-negativ zu
              arbeiten. Solche Vorhaben zeigen, dass eine nachhaltige
              Transformation der Cloud-Infrastruktur möglich ist und bereits in
              Angriff genommen wird.
              <br />
              <br />
              Für Unternehmen bringt die Green Cloud nicht nur ökologische,
              sondern auch ökonomische Vorteile. Energieeffiziente
              Cloud-Lösungen senken Betriebskosten und stärken das{" "}
              <strong> nachhaltige Image eines Unternehmens </strong> – ein
              Aspekt, der für immer mehr Kunden entscheidend wird. Darüber
              hinaus erleichtern nachhaltige Cloud-Technologien die Einhaltung
              internationaler Umweltstandards und Compliance-Vorgaben.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Laut einer Studie der Internationalen Energieagentur (IEA) könnten
              digitale Technologien bis 2030 bis zu 20% des globalen
              Energieverbrauchs ausmachen, wenn keine nachhaltigen Maßnahmen
              eingeführt werden. Cloud-Anbieter stehen daher in der
              Verantwortung, durch den Aufbau energieeffizienter Rechenzentren
              und den verstärkten Einsatz erneuerbarer Energien ihren Beitrag zu
              leisten.
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Quantencomputing in der Cloud</h3>
            <p className="col-lg-11 mx-auto">
              Quantencomputer eröffnen neue Möglichkeiten, komplexe Berechnungen
              um ein Vielfaches schneller und effizienter zu lösen als
              traditionelle Computer. Quantencomputer nutzen die Prinzipien der
              Quantenmechanik, wodurch sie Probleme in Sekunden lösen können,
              für die klassische Computer Jahre bräuchten. Klassische
              Bits können nur die Zustände 0 oder 1 annehmen. Quantencomputer verwenden Qubits, die aufgrund der Superposition ein beliebiges Verhältnis von 0 und 1 gleichzeitig annehmen können. Dadurch können sie viele Berechnungen parallel durchführen und komplexe Probleme effizienter lösen, als es mit klassischen Computern möglich wäre. 
              <br />
              <br />
              Quantencomputer sind aktuell noch extrem teuer und komplex. Sie können nur unter speziellen Bedingungen (z. B.
              Temperaturen nahe dem absoluten Nullpunkt) stabil arbeiten. Die
              Cloud ermöglicht Forschenden und Unternehmen den Zugriff auf
              Quantenressourcen, ohne in teure Hardware und deren Wartung
              investieren zu müssen. Damit könnten man Unternehmen weltweit
              transformative Vorteile in den Bereichen Medizin,
              Materialwissenschaften, Kryptografie und Finanzwesen ermöglichen,
              ohne das sie selbst kostspielige Quantenhardware besitzen zu
              müssen.
              <br />
              <br />
              Anbieter wie IBM mit ihrem IBM Quantum, Microsoft Azure Quantum
              und Google mit Sycamore bieten bereits Quantencomputing als
              Cloud-Services an, die Unternehmen und Forschungsinstitutionen
              testen und nutzen können.
              <br />
              <br />
              Obwohl Quantencomputing enormes Potenzial birgt, befindet sich die
              Technologie noch in einem frühen Entwicklungsstadium.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Holografische Kommunikation über die Cloud</h3>
            <p className="col-lg-11 mx-auto">
              Die holografische Kommunikation könnte dank Cloud-Technologien in
              den kommenden Jahren Realität werden und die Art und Weise, wie
              Menschen miteinander interagieren, grundlegend verändern. Diese
              Technologie kombiniert die Leistungsfähigkeit der Cloud mit{" "}
              <strong>Augmented Reality (AR) und Virtual Reality (VR), </strong>{" "}
              um 3D-Hologramme in Echtzeit darzustellen.
              <br />
              <br />
              Statt herkömmlicher Videokonferenzen könnten Teilnehmer in
              Meetings als virtuelle, dreidimensionale Hologramme erscheinen und
              interaktiv miteinander agieren. Diese Form der Kommunikation würde
              nicht nur die physische Präsenz imitieren, sondern auch eine
              realistischere und emotional stärker verbindende Interaktion
              ermöglichen. Anwendungen reichen von virtuellen Geschäftstreffen
              über immersive Bildungserfahrungen in Klassenzimmern bis hin zu
              medizinischen Konsultationen, bei denen ein Arzt „vor Ort“
              erscheinen kann, ohne tatsächlich reisen zu müssen.
              <br />
              <br />
              Die Cloud spielt dabei eine zentrale Rolle, da die enormen
              Datenmengen, die für die Erzeugung und Übertragung von Hologrammen
              erforderlich sind, nur durch die Skalierbarkeit und
              Geschwindigkeit cloudbasierter Dienste verarbeitet werden können.
              Fortschritte in der Latenzreduktion durch Technologien wie 5G und
              Edge Computing könnten holografische Kommunikation noch
              realistischer und zugänglicher machen.
              <br />
              <br />
              Langfristig könnte diese Technologie sogar physische Büros oder
              Konferenzen ersetzen und die Zusammenarbeit über Kontinente hinweg
              revolutionieren – ein echter Schritt in Richtung einer vollständig
              vernetzten, digitalen Welt.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pt-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

<h3 className="p-5">Space-Clouds</h3>
<p className="col-lg-11 mx-auto">
Mit dem starken Ausbau globaler Satellitennetze und immer leistungsfähigeren Trägerraketen gewinnt die Idee von sogenannten Space-Clouds zunehmend an Bedeutung. Gemeint ist damit die Verlagerung von Teilen der Cloud-Infrastruktur in den erdnahen Orbit. Unternehmen wie <strong>Project Kuiper</strong> von <strong>Amazon</strong> oder <strong>Starlink</strong> von <strong>SpaceX</strong> bauen derzeit riesige Satellitenkonstellationen auf, die weltweit Breitbandinternet bereitstellen. Während diese Systeme heute primär der Konnektivität dienen, entstehen parallel Konzepte, Rechenleistung näher an die Datenquelle – also direkt ins All – zu verlagern.
<br /><br />
Die Idee dahinter ist, Daten nicht erst über weite Strecken zu terrestrischen Rechenzentren zu übertragen, sondern bestimmte Verarbeitungsschritte direkt im Orbit durchzuführen. Das kann vor allem dort sinnvoll sein, wo große Datenmengen entstehen, etwa bei Erdbeobachtungssatelliten, militärischer Aufklärung oder globalen Sensornetzen. Werden Daten bereits im All vorverarbeitet oder gefiltert, reduziert das die Übertragungsmenge und beschleunigt Entscheidungen. Für Anwendungen mit sehr hohen Anforderungen an Verfügbarkeit und Resilienz kann eine orbital gestützte Infrastruktur zudem eine zusätzliche Sicherheitsebene darstellen.
<br /><br />
Ein weiterer Vorteil liegt in der globalen Reichweite. Satellitengestützte Cloud-Strukturen können Regionen anbinden, in denen terrestrische Netze fehlen oder instabil sind. Gerade in abgelegenen Gebieten, bei Naturkatastrophen oder in Krisensituationen kann eine weltraumgestützte Infrastruktur als unabhängige Kommunikations- und Datenebene dienen. Damit gewinnt das Thema auch aus geopolitischer und sicherheitspolitischer Sicht an Bedeutung.
<br /><br />
Gleichzeitig bleiben die technischen und wirtschaftlichen Herausforderungen erheblich. Der Aufbau, der Start und der Betrieb orbitaler Recheninfrastruktur sind teuer und komplex. Hardware muss extremen Temperaturunterschieden, Strahlung und Vibrationen standhalten. Zudem spielen Fragen der Nachhaltigkeit, der Energieversorgung und der Regulierung eine zentrale Rolle. Weltraumschrott und Kollisionsrisiken sind zusätzliche Faktoren, die langfristig berücksichtigt werden müssen.
<br /><br />
Stand 2026 befinden sich echte Rechenzentren im All jedoch weiterhin im Aufbau oder in Pilotphasen. Start-ups wie <strong> Lonestar Data Holdings </strong> arbeiten an hochsicheren Datenspeicherlösungen außerhalb der Erde und haben erste Demonstrationsmissionen umgesetzt. Dabei geht es weniger um klassische Massen-Clouds für Unternehmen, sondern eher um spezialisierte Backup-, Archiv- oder Sicherheitslösungen. Parallel dazu wird an Satelliten mit integrierter KI-Hardware geforscht, um Daten direkt im Orbit auswerten zu können.
<br /><br />
Gleichzeitig bleiben die Herausforderungen erheblich. Hardware muss extremen Temperaturunterschieden und Strahlung standhalten. Energieversorgung, Wartung, Weltraumschrott, regulatorische Fragen und hohe Investitionskosten sind zentrale Themen. Zudem ist bislang unklar, ob sich großflächige kommerzielle Cloud-Rechenzentren im All wirtschaftlich durchsetzen oder ob Space-Clouds langfristig ein Spezialsegment für sicherheitskritische oder wissenschaftliche Anwendungen bleiben.
</p>

          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter6_5;
